__webpack_require__.p = "/apps/spinball/game/";